import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { login, reset } from '../../features/auth/authSlice'
import Spinner from '../../components/spinner'
import { MDBInput } from 'mdb-react-ui-kit';
import Logo from "../../img/LogoName.png";
import Logores from "../../img/logoresponsive.png";
import '../../styles/index.css'
import { NewFooter } from "../../components/newFooter";

export function PractitionerLogin() {

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    })
    const [alert, setAlert] = useState(false)
    const { email, password } = formData


    const { user, isLoading, isError, isSuccess, message } = useSelector(
        (state) => state.auth
    )

    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        if (isError) {
            setAlert(true)
            toast.error(message)
        }

        if (user) {
            navigate('/newPractitionerProfile');
            window.location.reload(false);
        }

        dispatch(reset())
    }, [user, isError, isSuccess, message, navigate, dispatch])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }))
        setAlert(false)
    }

    const onKeyPress = (e) => {
        if (e.key === "Enter") {
            userLogin()
        }
    }

    const userLogin = () => {
        const practitionerUserData = {
            email,
            password,
        }

        dispatch(login(practitionerUserData));
        setFormData({
            email: '',
            password: '',
        })
    }

    const onSubmit = (e) => {
        e.preventDefault()
        userLogin()

    }

    if (isLoading) {
        return <Spinner />
    }

    console.log(alert)
    const getWindowDimensions = () => {
        const { innerWidth: width } = window;
        return {
            width,
        };
    }
    const windowWidth = getWindowDimensions();
    console.log(windowWidth)

    return (
        <>
            <div className="signupGradientbg2">
                {/* /////// singUpGradient control padding */}
                <div className="bgwhite2 row">

                    {/* /////// first part logo and icon*/}
                

                    {/* /////// second part titles*/}
                    <div className='d-flex justify-content-center '>
                    <div >
                            <div className='text-center pt-5'>
                                <h2 className="titlesingup text-center ">Practitioner Log In</h2>
                                <p className="labelsingup text-center text-dm">Don`t have an account? <br className='just-mobile'/> Click <span onClick={() => navigate("/practitionerSignUp")} className="pointer">here</span> to Sign Up</p>
                                <p className=" text-center my-0 text-dm text-10">Forgot password? Click <span onClick={() => navigate("/ForgotPasswordEmail")} className="pointer">here</span> to reset</p>
                            </div>
     
                     {alert && <div class="alert alert-danger w-50 text-center mx-auto p-1" role="alert">Invalid Credentials!</div>} 

                    {/* /////// third part inputs*/}

                    <div className="d-grid justify-content-center m-1 row pt-4">
                        <div className='col-sm  respo-new'>
                            <label className="labelsingup text-muted text-dm">Email</label>
                            <MDBInput
                                id='form1'
                                type='email'
                                className='form-control inputlogin input-border'
                                name='email'
                                value={email}
                                onChange={onChange}
                                onKeyPress={e => onKeyPress(e)} />
                        </div>

                        <div className='col-sm'>
                            <label className="labelsingup text-muted text-dm">Password</label>
                            <MDBInput
                                id='form1'
                                type='Password'
                                className='form-control inputlogin respo-new2 input-border'
                                name='password'
                                value={password}
                                onChange={onChange}
                                onKeyPress={e => onKeyPress(e)} />
                        </div>

                        <button className='login-button blue-hover text-dm mt-2' onClick={onSubmit}> LOG IN </button>
                    </div>
                        </div>
                        </div>
                </div>
            </div>
            <NewFooter show={windowWidth.width < 500 ? false : true} />
        </>
    )
}